var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.473 9H15.6308C13.6714 9 12.1038 10.6056 12.1038 12.5769V16.9487H10.1757C9.533 16.9487 9 17.4892 9 18.141C9 18.7928 9.533 19.3333 10.1757 19.3333H12.1038V23.3077H10.1757C9.533 23.3077 9 23.8482 9 24.5C9 25.1518 9.533 25.6923 10.1757 25.6923H12.1038V29.6667H10.1757C9.533 29.6667 9 30.2072 9 30.859C9 31.5108 9.533 32.0513 10.1757 32.0513H12.1038V36.4231C12.1038 38.3944 13.687 40 15.6308 40H34.473C36.4168 40 38 38.3944 38 36.4231V12.5769C38 10.6056 36.4168 9 34.473 9ZM25.0362 15.9631C27.3562 15.9631 29.2373 17.8708 29.2373 20.2236C29.2373 22.5764 27.3562 24.4841 25.0362 24.4841C22.7162 24.4841 20.8351 22.5764 20.8351 20.2236C20.8351 17.8708 22.7162 15.9631 25.0362 15.9631ZM32.8741 31.9082C32.8741 33.2754 31.8865 34.3723 30.6638 34.3723H19.4086C18.1859 34.3723 17.1984 33.2595 17.1984 31.9082V30.3979C17.1984 29.3805 17.747 28.4744 18.5935 28.0928C22.7162 26.2964 27.3405 26.2964 31.4632 28.0928C32.3097 28.4585 32.8584 29.3646 32.8584 30.3821V31.8923L32.8741 31.9082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookUser);
export default __webpack_public_path__ + "static/media/book-user.8f2d931010967bbf53d8d7d3297fe490.svg";
export { ForwardRef as ReactComponent };